export const DDConfig = {
  hub: {
    enabled: process.env.REACT_APP_DD_CLIENT_LOG_ENABLED === 'true' || false,
    clientToken: process.env.REACT_APP_DATADOG,
    env: process.env.REACT_APP_DD_CLIENT_LOG_ENV,
  },
};
